import { render, staticRenderFns } from "./DomainHosting.vue?vue&type=template&id=1efe1645&"
import script from "./DomainHosting.vue?vue&type=script&lang=js&"
export * from "./DomainHosting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports